import React from 'react'
import { modalVariants } from 'utils/frame-motion-variants'
import { motion } from 'framer-motion'

export const TrainerSelectionGuide = ({setIsShowTrainerGuide}) => {
return (
    <div className="fixed inset-0 z-30 flex justify-center items-center pt-2 pb-2 backdrop-blur-sm bg-black/10 overflow-y-auto">
        <motion.div
            className="m-1 max-w-3xl w-full bg-white rounded-lg shadow text-black"
            variants={modalVariants}
            initial="initial"
            animate="animate"
            exit="exit"
        >
            <div className="flex justify-center items-center rounded-t border-b p-4">
                <h3 className="font-bold px-2 text-lg">
                    Trainer Selection Guide
                </h3>
                <button type="button" onClick={() => setIsShowTrainerGuide(false)} className=" text-gray-200 hover:bg-gray-200 hover:text-gray-900 rounded-full text-sm p-1.5 ml-auto bg-gray-600">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>  
                </button>
            </div>
            <div className='p-4 max-h-[70vh] overflow-y-auto '>
                <div className="space-y-6">
                    <div className="flex items-start">
                        <span className="text-2xl mr-3">💪</span>
                        <div>
                            <h4 className="font-semibold text-md mb-1">Essential Trainers</h4>
                            <ul className="list-disc ml-5">
                                <li>Certified fitness professionals with <span className="font-bold">less than 1 year of personal training experience</span>.</li>
                                <li>Energetic, passionate, and perfect for <span className="font-bold">beginners</span> who need motivation and guidance.</li>
                                <li>Ideal for building strength, mobility, and confidence in your fitness journey.</li>
                                <li>Best for those starting their fitness journey and need consistent support.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="flex items-start">
                        <span className="text-2xl mr-3">⚡</span>
                        <div>
                            <h4 className="font-semibold text-md mb-1">Signature Trainers</h4>
                            <ul className="list-disc ml-5">
                                <li>Professionals with <span className="font-bold">over 2 years of experience</span> and proven track records.</li>
                                <li>Specialize in strength training, endurance, and progressive transformation programs.</li>
                                <li>Best suited for individuals who <span className="font-bold">already exercise</span> but want expert guidance.</li>
                                <li>Help you push past plateaus and level up your performance.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="flex items-start">
                        <span className="text-2xl mr-3">🔥</span>
                        <div>
                            <h4 className="font-semibold text-md mb-1">Elite Trainers</h4>
                            <ul className="list-disc ml-5">
                                <li>Highly qualified professionals with <span className="font-bold">more than 5 years of experience</span>.</li>
                                <li>Train clients across all fitness levels — from general fitness to <span className="font-bold">competitive athletes</span>.</li>
                                <li>Deliver customized, high-performance programs focused on precision and peak conditioning.</li>
                                <li>Ideal for those serious about achieving the best version of themselves.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="mt-6 bg-gray-50 rounded p-3 border text-sm text-gray-700">
                        <strong>Choosing Your Trainer:</strong> Select Essential if you&apos;re new to fitness and need foundational guidance. Choose Signature if you have workout experience and want to advance your results. Pick Elite if you&apos;re committed to high-performance training and body transformation goals.
                    </div>
                </div>
            </div>
        </motion.div>
    </div>
)
}
